var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tour-add-ons__wrapper" }, [
    _c("div", { staticClass: "tour-add-ons__collapse-header" }, [
      _c("h2", { staticClass: "tour-add-ons__title" }, [
        _vm._v(_vm._s(_vm.data.title)),
      ]),
      _vm._v(" "),
      _vm.isMobile()
        ? _c("span", {
            staticClass: "add-ons__arrow add-ons__row--open",
            on: { click: _vm.hideShowAddonsList },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tour-add-ons__description" }, [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.data.descriptionHtml) } }),
    ]),
    _vm._v(" "),
    this.openAddonsList
      ? _c("div", { staticClass: "tour-add-ons__collapse-body" }, [
          _c(
            "div",
            { staticClass: "personalise-wrapper" },
            _vm._l(_vm.visibleItems, function (addon) {
              return _c("AddOn", {
                key: addon.code,
                attrs: { addon: addon, data: _vm.data, brand: _vm.brand },
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.isButtonVisible
            ? _c("div", { staticClass: "cta-holder personalise-cta" }, [
                _c(
                  "button",
                  { staticClass: "btn", on: { click: _vm.toggleAmount } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.isViewAll
                          ? _vm.data.showLessResultsText
                          : _vm.data.showMoreResultsText
                      )
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }